import { isEmpty, isEmptyArray, isNullOrUndefined } from './index'

// 👉 Required Validator
export const requiredValidator = value => {
  if (isNullOrUndefined(value) || isEmptyArray(value) || value === false)
    return 'This field is required'

  return !!String(value).trim().length || 'This field is required'
}

export const nameValidator = value => {
  //if name has a space at either end return error
  if (value == null || value.length == 0 || value.trim().length == 0)
    return 'Name is a required field'
}

// 👉 Email Validator
export const phoneValidator = value => {
  if (isEmpty(value))
    return true
  const re = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
  if (Array.isArray(value))
    return value.every(val => re.test(String(val))) || 'Use (123) 456-7890 format'

  return re.test(String(value)) || 'Use (123) 456-7890 format'
}

// 👉 Email Validator
export const emailValidator = value => {
  if (isEmpty(value))
    return true
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (Array.isArray(value))
    return value.every(val => re.test(String(val))) || 'Must be a valid email'
  
  return re.test(String(value)) || 'Must be a valid email'
}

// 👉 Password Validator
export const passwordValidator = password => {
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  const validPassword = regExp.test(password)
  
  return (
    // eslint-disable-next-line operator-linebreak
    validPassword ||
        'Field must contain at least one uppercase, lowercase, special character and digit with min 8 chars')
}

// 👉 Confirm Password Validator
export const confirmedValidator = (value, target) => value === target || 'The Confirm Password field confirmation does not match'

// 👉 Between Validator
export const betweenValidator = (value, min, max) => {
  const valueAsNumber = Number(value)
  
  return (Number(min) <= valueAsNumber && Number(max) >= valueAsNumber) || `Enter number between ${min} and ${max}`
}

// 👉 Integer Validator
export const integerValidator = value => {
  if (isEmpty(value))
    return true
  if (Array.isArray(value))
    return value.every(val => /^-?[0-9]+$/.test(String(val))) || 'This field must be an integer'
  
  return /^-?[0-9]+$/.test(String(value)) || 'This field must be an integer'
}

// 👉 Regex Validator
export const regexValidator = (value, regex) => {
  if (isEmpty(value))
    return true
  let regeX = regex
  if (typeof regeX === 'string')
    regeX = new RegExp(regeX)
  if (Array.isArray(value))
    return value.every(val => regexValidator(val, regeX))
  
  return regeX.test(String(value)) || 'The Regex field format is invalid'
}

// 👉 Alpha Validator
export const alphaValidator = value => {
  if (isEmpty(value))
    return true
  
  return /^[A-Z]*$/i.test(String(value)) || 'The Alpha field may only contain alphabetic characters'
}

// 👉 URL Validator
export const urlValidator = value => {
  if (isEmpty(value))
    return true
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/

  return re.test(String(value)) || 'URL is invalid'
}

//similar to above but profileIdValidator is for the profileId field and makes sure length is < 40, and only uses lowercase letters numbers and hyphen
export const profileIdValidator = value => {
  if (isEmpty(value))
    return 'Can not be blank'
  const re = /^[a-z0-9-]{1,40}$/

  return re.test(String(value)) || 'lowercase letters, numbers and hyphen'
}

export const linkedInProfileValidator = value => {
  const re = /^[a-zA-Z0-9\-\/]{3,100}$/
  if (!re.test(value)) {
    return 'LinkedIn profile id must be 3-100 characters long and contain only letters, numbers, and hyphens'
  }
  if (/linkedin/i.test(value)) {
    return 'Cannot contain the word "LinkedIn"'
  }
  
  return true
}

export const instagramProfileValidator = value => {
  const re = /^[a-zA-Z0-9._]{1,30}$/
            
  if (!re.test(value)) {
    return 'Must be 1-30 characters long and contain only letters, numbers, periods, and underscores'
  }
  
  return true
}

export const xProfileValidator = value => {
  const re = /^[a-zA-Z0-9_]{1,15}$/
  if (!re.test(value)) {
    return 'Must be 1-15 characters long and contain only letters, numbers, and underscores'
  }
  
  return true
}

export const tiktokProfileValidator = value => {
  const re = /^[a-zA-Z0-9._]{2,24}$/
  if (!re.test(value)) {
    return 'Must be 2-24 characters long and contain only letters, numbers, periods, and underscores'
  }
  
  return true
}

export const reservationPlatformUrlValidator = value => {
  if (isEmpty(value)) return true

  // Check if it starts with https://
  if (!value.startsWith('https://')) return 'URL must start with https://'

  // Check if it ends with /
  if (value.endsWith('/')) return 'URL must not end with a /'

  // Check if it ends with /
  if (value.endsWith('/search')) return 'URL must not end /search'

  // Check for existence of ? or &
  if (value.includes('?') || value.includes('&')) return 'URL should not contain "?" or "&"'

  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/

  return re.test(String(value)) || 'URL is invalid'
}

// 👉 Length Validator
export const lengthValidator = (value, length) => {
  if (isEmpty(value))
    return true
  
  return String(value).length === length || `The Min Character field must be at least ${length} characters`
}

// 👉 Alpha-dash Validator
export const alphaDashValidator = value => {
  if (isEmpty(value))
    return true
  const valueAsString = String(value)
  
  return /^[0-9A-Z_-]*$/i.test(valueAsString) || 'All Character are not valid'
}
